var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1091 12.2614C11.4272 12.5795 11.9431 12.5795 12.2613 12.2614C12.5795 11.9432 12.5795 11.4272 12.2613 11.1091L7.65228 6.49998L12.2614 1.89091C12.5795 1.57272 12.5795 1.05683 12.2614 0.738643C11.9431 0.420452 11.4272 0.420452 11.1091 0.738643L6.49999 5.34768L1.89091 0.738653C1.57272 0.420463 1.05683 0.420463 0.738643 0.738653C0.420452 1.05684 0.420452 1.57274 0.738643 1.89093L5.34769 6.49998L0.738653 11.1091C0.420463 11.4272 0.420463 11.9431 0.738653 12.2614C1.05684 12.5795 1.57273 12.5795 1.89092 12.2614L6.49999 7.65227L11.1091 12.2614Z",
    fill: "#8F90A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/iconClose.896bd633.svg";
export { ForwardRef as ReactComponent };